module.exports = __webpack_public_path__ + "img/brand-03.3c22f8c5.png";